import { Box, Button, Typography } from "@mui/material";
import { Add, ReceiptLong } from "@mui/icons-material";
import { MetodoPagamentoSelect } from "../../MetodoPagamentoSelect";
import { useChatPdVContext } from "../../../contexts/atendimento/ChatPdVContext";
import { TipoPedido } from "../../../enum/TipoPedido";
import { IPagamentoPedido } from "../../../interface/IPagamentoPedido";
import { IProdutoPedido } from "../../../interface/IProdutoPedido";
import { TipoProduto } from "../../../../produtos/enum/TipoProduto";
import { BotoesAcoesCheckout } from "../../BotoesAcoesCheckout";
import { useState } from "react";
import { ChatPdVValores } from "./components/ChatPdVValores";
import { ChatPdVEndereco } from "./components/ChatPdVEndereco";
import { ChatPdVTipoPedidoRadio } from "./components/ChatPdVTipoPedidoRadio";
import { ChatPdVPedidosEmAndamento } from "./components/ChatPdVPedidosEmAndamento";
import { ChatPdVCarrinho } from "./components/ChatPdVCarrinho";
import { ChatPdVSelecionarCliente } from "./components/ChatPdVSelecionarCliente";
import { ChatPdVClienteVinculado } from "./components/ChatPdVClienteVinculado";
import { CuponsDrawer } from "../../CuponsDrawer";
import { FidelidadeCardsWrapper } from "../../FidelidadeCardsWrapper";
import { useFetchCategorias } from "../../../../produtos/hooks/useFetchCategorias";
import { ChatPdVCatalogo } from "./components/ChatPdVCatalogo";
import { ChatPdVFormPizza } from "./components/ChatPdVFormPizza";
import { ChatPdVFormPreparado } from "./components/ChatPdVFormPreparado";
import { ChatPdVFormPeso } from "./components/ChatPdVFormPeso";
import { acaoPrincipal, contorno, cores, raio, texto } from "../identidade";

export const ChatPdVContent = () => {
    const { categorias } = useFetchCategorias();
    const {
        adicionarProduto,
        tipo,
        pagamentos,
        produtos,
        fecharPedido,
        loading,
        agendarHorario,
        agendadoPara,
        alterarPagamentos,
        switchNotaFiscal,
        handleSwitchNotaFiscal,
        configuracaoNFCe,
        switchImprimirAutomatico,
        handleSwitchImprimirAutomatico,
        valorTotalPedido,
        pedidosEmAndamento,
        exibirNovoPedido,
        cupons,
        abrirDrawerCupons,
        fecharDrawerCupons,
        drawerCuponsAberto,
        aplicarCupom,
        removerCupom,
        valorFrete,
        valorTotalProdutos,
        cliente,
        aumentarQuantidade,
        diminuirQuantidade,
        removerProduto,
        navegarParaFormPizza,
        navegarParaFormPreparado,
        navegarParaFormPeso,
        navegarParaCatalogo,
        telaAtual,
    } = useChatPdVContext();

    const handleEditarProduto = (produto: IProdutoPedido) => {
        if (produto.tipo === TipoProduto.pizza) {
            navegarParaFormPizza(produto, 'checkout');
        } else if (produto.tipo === TipoProduto.preparado) {
            navegarParaFormPreparado(produto, 'checkout');
        } else if (produto.tipo === TipoProduto.peso) {
            navegarParaFormPeso(produto, 'checkout');
        }
    };

    const [mostrarHorario, setMostrarHorario] = useState(false);

    const handleAlterarPagamento = (pagamento?: IPagamentoPedido) => {
        if (!pagamento?.metodoPagamento) {
            alterarPagamentos(undefined);
        } else {
            alterarPagamentos([pagamento]);
        }
    };

    const handleConcluir = () => {
        fecharPedido();
    };

    // Se há pedidos em andamento e não foi escolhido exibir novo pedido, mostrar lista de pedidos
    const mostrarPedidosEmAndamento = pedidosEmAndamento && pedidosEmAndamento.length > 0 && !exibirNovoPedido;

    // Se não tem cliente vinculado, mostrar tela de seleção
    const mostrarSelecaoCliente = !cliente && !mostrarPedidosEmAndamento;

    // Views que sobrepõem a navegação normal
    if (mostrarPedidosEmAndamento) {
        return (
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', p: 1.75, gap: 1.5, overflowY: 'auto', minHeight: 0 }}>
                <ChatPdVPedidosEmAndamento />
            </Box>
        );
    }

    if (mostrarSelecaoCliente) {
        return (
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', p: 1.75, gap: 1.5, overflowY: 'auto', minHeight: 0 }}>
                <ChatPdVSelecionarCliente />
            </Box>
        );
    }

    if (telaAtual === 'catalogo') {
        return <ChatPdVCatalogo />;
    }

    if (telaAtual === 'pizza') {
        return <ChatPdVFormPizza />;
    }

    if (telaAtual === 'preparado') {
        return <ChatPdVFormPreparado />;
    }

    if (telaAtual === 'peso') {
        return <ChatPdVFormPeso />;
    }

    return (
        <>
            {/* Cabeçalho da coluna, como no site: o pedido nasce dentro da conversa. */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 2,
                    py: 1.5,
                    flexShrink: 0,
                    borderBottom: theme => contorno(theme, 0.09),
                }}
            >
                <ReceiptLong sx={{ fontSize: 16, color: cores.marca[400] }} />
                <Typography sx={{ ...texto.secao, color: 'text.secondary', flex: 1 }}>
                    Pedido no chat
                </Typography>

                {/* Adicionar itens vive aqui: é a coluna onde o pedido é montado. */}
                <Button
                    onClick={navegarParaCatalogo}
                    startIcon={<Add sx={{ fontSize: 16 }} />}
                    sx={theme => ({
                        ...acaoPrincipal(theme),
                        flexShrink: 0,
                        fontSize: '11.5px',
                        borderRadius: raio.pill,
                        px: 1.5,
                        py: 0.6,
                        minWidth: 0,
                        '& .MuiButton-startIcon': { mr: 0.5 },
                    })}
                >
                    Itens
                </Button>
            </Box>

            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    px: 1.75,
                    py: 1.75,
                    gap: 1.75,
                    overflowY: 'auto',
                    minHeight: 0,
                }}
            >
                {/* Tipo de Pedido */}
                <ChatPdVTipoPedidoRadio />

                {/* Valores do Pedido */}
                <ChatPdVValores />

                {/* Carrinho */}
                {produtos.length > 0 && (
                    <Box sx={{ mt: 1 }}>
                        <Typography sx={{ ...texto.secao, color: 'text.secondary', mb: 1.25 }}>
                            Carrinho · {produtos.length} {produtos.length === 1 ? 'item' : 'itens'}
                        </Typography>
                        <Box
                            sx={{
                                maxHeight: 320,
                                overflow: 'auto',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                            }}
                        >
                            <ChatPdVCarrinho
                                produtos={produtos}
                                onAumentarQuantidade={aumentarQuantidade}
                                onDiminuirQuantidade={diminuirQuantidade}
                                onRemoverProduto={removerProduto}
                                onEditarProduto={handleEditarProduto}
                            />
                        </Box>
                    </Box>
                )}

                {/* Cliente vinculado (abaixo do carrinho, acima do endereço) */}
                <ChatPdVClienteVinculado />

                {/* Endereço (apenas se delivery) */}
                {tipo === TipoPedido.delivery && (
                    <ChatPdVEndereco />
                )}

                <FidelidadeCardsWrapper
                    cliente={cliente}
                    cupons={cupons}
                    aplicarCupom={aplicarCupom}
                    adicionarProduto={adicionarProduto}
                    categorias={categorias || []}
                    produtos={produtos}
                />

                {/* Método de Pagamento */}
                <MetodoPagamentoSelect
                    pagamento={pagamentos[0]}
                    onChange={handleAlterarPagamento}
                    valorTotal={valorTotalPedido}
                />

                <BotoesAcoesCheckout
                    switchImprimirAutomatico={switchImprimirAutomatico}
                    handleSwitchImprimirAutomatico={handleSwitchImprimirAutomatico}
                    switchNotaFiscal={switchNotaFiscal}
                    handleSwitchNotaFiscal={handleSwitchNotaFiscal}
                    configuracaoNFCeObrigatorio={configuracaoNFCe?.obrigatorio}
                    agendadoPara={agendadoPara}
                    agendarHorario={agendarHorario}
                    mostrarHorario={mostrarHorario}
                    toggleHorario={() => setMostrarHorario(!mostrarHorario)}
                    quantidadeCupons={cupons.length}
                    abrirDrawerCupons={abrirDrawerCupons}
                />
            </Box>
            <Button
                variant="contained"
                fullWidth
                onClick={handleConcluir}
                disabled={loading || produtos.length === 0}
                sx={theme => ({
                    ...acaoPrincipal(theme),
                    flexShrink: 0,
                    height: 60,
                    borderRadius: 0,
                    fontSize: '13.5px',
                })}
            >
                {loading ? "Processando..." : "Concluir pedido"}
            </Button>
            <CuponsDrawer
                aberto={drawerCuponsAberto}
                fechar={fecharDrawerCupons}
                cuponsAplicados={cupons}
                aplicarCupom={aplicarCupom}
                removerCupom={removerCupom}
                valorFrete={valorFrete}
                valorTotalProdutos={valorTotalProdutos}
            />
        </>
    );
};
